import React from 'react';
import PropTypes from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';

import { GuestHomepage } from './GuestHomepage';

export const GuestHomepageContainer = ({ slug }) => {
  return (
    <ErrorBoundary name="my-homepage-content">
      <QueryProvider cacheKey="consumer-homepage">
        <GuestHomepage slug={slug} />
      </QueryProvider>
    </ErrorBoundary>
  );
};

GuestHomepageContainer.propTypes = {
  slug: PropTypes.string,
};

GuestHomepageContainer.defaultProps = {
  slug: undefined,
};
